import type { ErrorMessage } from '@/core/api/error-messages';

export const REGION_ERRORS: Record<string, ErrorMessage> = {
  'Region.NotFound': {
    title: 'Región no encontrada',
    message: 'La región solicitada no existe.',
    severity: 'error',
  },
  'Region.NameRequired': {
    title: 'Nombre requerido',
    message: 'El nombre es obligatorio.',
    severity: 'error',
  },
  'Region.NameTooShort': {
    title: 'Nombre muy corto',
    message: 'El nombre debe tener al menos 2 caracteres.',
    severity: 'error',
  },
  'Region.NameTooLong': {
    title: 'Nombre muy largo',
    message: 'El nombre no puede exceder 150 caracteres.',
    severity: 'error',
  },
  'Region.NameAlreadyExists': {
    title: 'Nombre duplicado',
    message: 'El nombre ya se encuentra registrado para la configuración territorial seleccionada.',
    severity: 'error',
  },
  'Region.CountryNotFound': {
    title: 'País no encontrado',
    message: 'El país especificado no existe.',
    severity: 'error',
  },
  'Region.CountryMustBeActive': {
    title: 'País inactivo',
    message: 'El país debe estar activo para registrar regiones.',
    severity: 'error',
  },
  'Region.ParentMustBeSameCountry': {
    title: 'Región padre inválida',
    message: 'La región padre debe pertenecer al mismo país.',
    severity: 'error',
  },
  'Region.ParentMustBeSameType': {
    title: 'Tipo de región inválido',
    message: 'La región padre debe ser del mismo tipo.',
    severity: 'error',
  },
  'Region.ParentScopeIncompatible': {
    title: 'Región padre incompatible',
    message: 'La región padre debe abarcar el mismo alcance territorial que la región hija.',
    severity: 'error',
  },
  'Region.HierarchyCycleDetected': {
    title: 'Ciclo jerárquico',
    message: 'No se permite crear ciclos jerárquicos en las regiones.',
    severity: 'error',
  },
  'Region.InvalidParentId': {
    title: 'ID de región padre inválido',
    message: 'El ID de la región padre debe ser un número válido.',
    severity: 'error',
  },
  'Region.HasDependencies': {
    title: 'Región con dependencias',
    message:
      'No se puede cambiar el país o tipo de una región que tiene dependencias (regiones hijas).',
    severity: 'error',
  },
  'Region.RegionMustBeDisabled': {
    title: 'Región activa',
    message: 'Debe deshabilitarse antes de eliminar.',
    severity: 'error',
  },
};
